/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseGetAllStatusResponse
 */
export interface ResponseGetAllStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof ResponseGetAllStatusResponse
     */
    displayOrder?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseGetAllStatusResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseGetAllStatusResponse
     */
    name?: string;
}

/**
 * Check if a given object implements the ResponseGetAllStatusResponse interface.
 */
export function instanceOfResponseGetAllStatusResponse(value: object): value is ResponseGetAllStatusResponse {
    return true;
}

export function ResponseGetAllStatusResponseFromJSON(json: any): ResponseGetAllStatusResponse {
    return ResponseGetAllStatusResponseFromJSONTyped(json, false);
}

export function ResponseGetAllStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetAllStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'displayOrder': json['display_order'] == null ? undefined : json['display_order'],
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ResponseGetAllStatusResponseToJSON(json: any): ResponseGetAllStatusResponse {
    return ResponseGetAllStatusResponseToJSONTyped(json, false);
}

export function ResponseGetAllStatusResponseToJSONTyped(value?: ResponseGetAllStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'display_order': value['displayOrder'],
        'id': value['id'],
        'name': value['name'],
    };
}

